export default __webpack_public_path__ + "static/media/background0.5812f0e4.png";